import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center text-xl"
}
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = { class: "table-index-cell" }
const _hoisted_4 = { class: "table-index-cell__order" }
const _hoisted_5 = { class: "table-index-cell__id" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}, " Nhóm toa xe ", -1)
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_ToaXeDetailModal = _resolveComponent("ToaXeDetailModal")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_BaseLink = _resolveComponent("BaseLink")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationDialog, {
      title: "Xác nhận",
      size: "sm",
      "is-display": _ctx.isDeletingModalDisplay,
      onOnConfirmButtonClick: _ctx.confirmDelete,
      onOnCloseButtonClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDeletingModalDisplay = false)),
      onOnCloseIconClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDeletingModalDisplay = false))
    }, {
      default: _withCtx(() => [
        (_ctx.deletingToaXe)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_1, [
              _createTextVNode(" Bạn hãy chắc chắn muốn xóa toa xe "),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.deletingToaXe.ten_toa_xe), 1),
              _createTextVNode("? ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-display", "onOnConfirmButtonClick"]),
    _createVNode(_component_ToaXeDetailModal, {
      id: _ctx.selectedToaXeId,
      "show-delete-toa-xe-button": 
			_ctx.showDeleteToaXeButtonInModal && _ctx.canDeleteToaXe(_ctx.deletingToaXe)
		,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedToaXeId = undefined))
    }, null, 8, ["id", "show-delete-toa-xe-button"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      "empty-text": "Chưa có toa xe nào được tạo",
      size: "medium",
      style: {"width":"100%"},
      border: true,
      data: _ctx.items,
      "row-class-name": _ctx.rowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "STT",
          width: "70"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.indexCal(scope.$index, _ctx.curPage, _ctx.perPage)), 1),
              _createElementVNode("span", _hoisted_5, "(" + _toDisplayString(scope.row.id) + ")", 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Tên",
          width: "300"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ten_toa_xe), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Số hiệu",
          width: "130"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.so_hieu), 1)
          ]),
          _: 1
        }),
        (_ctx.showDmToaXe)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              width: "300"
            }, {
              header: _withCtx(() => [
                _hoisted_6
              ]),
              default: _withCtx((scope) => [
                (scope.row.danh_muc_toa_xe.length)
                  ? (_openBlock(), _createBlock(_component_BaseLink, {
                      key: 0,
                      style: {"word-break":"break-word !important"},
                      to: {
						name: 'chi-tiet-danh-muc-toa-xe',
						params: {
							id: scope.row.danh_muc_toa_xe[0].id,
						},
					}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.danh_muc_toa_xe[0].ten_danh_muc), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_7, "-"))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, { label: "Ghi chú" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ghi_chu ? scope.row.ghi_chu : '-'), 1)
          ]),
          _: 1
        }),
        (_ctx.showMaToaXe)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              label: "Mã toa xe",
              width: "130"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.ma_toa_xe), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showChungLoai)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              label: "Chủng loại",
              width: "130"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.chung_loai_toa_xe?.ky_hieu
					? scope.row.chung_loai_toa_xe.ky_hieu
					: '-'), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          width: "70",
          fixed: "right",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_Setting, {
              actions: _ctx.getSettingActions(scope.row)
            }, null, 8, ["actions"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "row-class-name"])), [
      [_directive_loading, _ctx.isLoading]
    ])
  ], 64))
}